import Link from "../Link";

const Javascript = () => {
    return (
        <div>
            <Link url="https://campus.open-bootcamp.com/cursos/15" title={"OpenBootcamp JavaScript"} />
        </div>
    );
}

export default Javascript;